seedWebApp.controller('StatusController', ['$scope', '$rootScope', '$uibModal', 'ToastService', 'TranslationService', 'StoreService',
    function ($scope, $rootScope, $uibModal, ToastService, TranslationService, StoreService) {

        console.log('statusController');

        $scope.translation = TranslationService.getActiveTranslation();
        $scope.prefs = {
            name: 'RefersGrid',
            sortByCol: null,
            canAdd: true,
            canEdit: true,
            canDelete: false,
        };

        $scope.idClass = function (item) {
            return 'agp-color';
        };

        $scope.seqClass = function (item) {
            return 'sd-border-label';
        };

        $scope.columns = [
            { name: 'StatusID', display: 'ID', orderBy: 'asc', editable: false, width: 10, isKey: true, customClass: $scope.idClass },  //filterOptions: [] 
            { name: 'StatusSeq', display: 'Sequência', editable: true, width: 15, customClass: $scope.seqClass },            
            { name: 'StatusName', display: 'Status', editable: true, width: 25 },            
            { name: 'StatusDescription', display: 'Descrição', editable: true, width: 25 },
            { name: 'ForeColor', display: 'Cor Fonte', filterOptions: [], editable: true, width: 15, dataType: 'color' },
            { name: 'BackColor', display: 'Cor Fundo', filterOptions: [], editable: true, width: 15, dataType: 'color' },
            //{ name: 'IsClosed', display: 'Fechado', filterOptions: [], editable: true, width: 15, dataType: 'boolean' },
            { name: 'IsClosed', display: 'Fechado', filterOptions: [], editable: true, width: 15, dataType: 'boolean' },
        ];

        $scope.prefs.sortByCol = $scope.columns[0];
        $scope.prefs.sortByCol.orderReverse = false;

        $scope.loadService = StoreService.getStatus;
        $scope.resetService = StoreService.resetCache;
        //$scope.loadColumns = ContactService.getContactsColumns;

        $scope.getTotal = function () {
            $scope.loadingTotal = true;
            StoreService.getStatusCount().then(function (response) {
                $scope.loadingTotal = false;
                if (response) {
                    $scope.totalItems = response.data.TotalCount;
                    $scope.lastSync = response.data.LastSync;
                }

            });
        };

        $scope.getTotal();

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'status');
        };

        $scope.prefs.customEdit = function (status) {
            $scope.editStatus(status);
        };

        $scope.editStatus = function (status) {
            //$scope.$broadcast('addItem');
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/Settings/statusModal.html',
                controller: 'StatusModalController',
                size: 'md',
                resolve: {
                    status: function () {
                        return status;
                    }
                }
            });

            modalInstance.result.then(function (status) {
                $scope.doRefresh();
            });

        };

        $scope.doInsert = function () {
            //$scope.$broadcast('addItem');
            //var newStatus = {
            //    StatusID: 'ADD_NEW',
            //};
            $scope.editStatus(null);
        };

        //$scope.insertNew = function () {
        //    MaterialService.openMaterialModal();
        //}

        //$(document).ready(function () {
        //    $scope.overflowSize = $scope.AdjustSize();
        //});

    }]
);
